import gsap from "gsap";
import { Scene } from "onearm";
import { SpineAnimation } from "onearm";

export class TransitionScene extends Scene {

    /**
     * @param {Object} options
     */
    create(options) {
        this.spine = this.createObject(SpineAnimation, {
            params: {
                spine: "TransitionAnimation",
                animation: "transition",
            },
            x: "50%",
            y: "50%",
            scale: (options.screen.mode === "landscape" || options.screen.mode === "portrait") ? 2.5 : 1.5,
        });
        this.spine.stop();
        this.spine.goToStart();
    }

    /**
     * @description Plays transition animation
     * @returns {gsap.core.Timeline}
     */
    transition() {
        const tl = gsap.timeline();

        const duration = this.spine.getAnimationDuration();

        tl.to(
            this.spine,
            {
                duration,
                onStart: () => {
                    this.show();
                    this.spine.play();
                },
                onComplete: () => {
                    this.hide();
                },
            },
            0,
        );

        return tl;
    }
}

